import axios, { AxiosError, AxiosInstance } from 'axios';

export interface FilterData {
  bu: string[];
  distributors: string[];
  states: string[];
  cities: Array<{ municipio: string; uf: string }>;
}

export interface FilterParams {
  unidadeDeNegocio?: string;
  distribuidor?: string;
  uf?: string;
  municipio?: string;
}

export interface CityGeoJSON {
  name: string;
  geojson: string;
}

export interface FilteredDataResponse {
  success: boolean;
  data: {
    success: boolean;
    columns: string[];
    data: string[][];
    cities: CityGeoJSON[];
  };
}

export const fetchFilters = async (): Promise<FilterData> => {
  try {
    const response = await axios.get(`/seller_mapping/filters`);

    if (!response.data.success) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.data;
    
    if (!result.success) {
      throw new Error('Invalid response format');
    }

    const buList = result.data.bu.data.map((item: string[]) => item[0]);
    const distributorsList = result.data.distributors.data.map((item: string[]) => item[0]);
    const citiesData = result.data.cityUF.data.map((item: string[]) => ({
      municipio: item[0],
      uf: item[1]
    }));

    const uniqueStates = Array.from(new Set(citiesData.map((c:any) => c.uf))).sort();

    return {
      bu: buList,
      distributors: distributorsList,
      states: citiesData.map((c:any) => c.uf).filter((v:any, i:any, a:any) => a.indexOf(v) === i).sort(),
      cities: citiesData
    };
  } catch (error) {
    console.error('Error fetching filters:', error);
    return {
      bu: [],
      distributors: [],
      states: [],
      cities: []
    };
  }
};

export const fetchFilteredData = async (params: FilterParams): Promise<FilteredDataResponse> => {
  try {
    const queryParams = new URLSearchParams();

    if (params.unidadeDeNegocio && params.unidadeDeNegocio !== 'Todos') {
      queryParams.append('unidadeDeNegocio', params.unidadeDeNegocio);
    }
    if (params.distribuidor && params.distribuidor !== 'Todos') {
      queryParams.append('distribuidor', params.distribuidor);
    }
    if (params.uf && params.uf !== 'Todos') {
      queryParams.append('uf', params.uf);
    }
    if (params.municipio && params.municipio !== 'Todos') {
      queryParams.append('Municipio', params.municipio);
    }

    const url = `/seller_mapping/filter-by${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

    const response = await axios.get(url);

    if (!response.data.success) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.data;
    return result;
  } catch (error) {
    console.error('Error fetching filtered data:', error);
    return {
      success: false,
      data: {
        success:false,
        columns: [],
        data: [],
        cities: []
      }
    };
  }
};
